import { Pipe, PipeTransform } from '@angular/core';
import { PaymentMethodType } from '@platform-frontend/marketplace';
import { IconName } from '@platform-frontend/ui-tools';

@Pipe({
  name: 'addPaymentMethodTypeIcon'
})
export class AddPaymentMethodTypeIconPipe implements PipeTransform {
  transform(value: PaymentMethodType, variant: 'duo' | 'outline' | null = null): IconName | null {
    switch (value) {
      case 'APPLE_PAY':
        return 'apple-pay';
      case 'CREDIT_CARD':
        return variant === 'duo' ? 'add-credit-card-duo' : variant ? 'add-credit-card-duo-outline' : 'add-credit-card';
      case 'DIRECT_DEBIT':
        return variant === 'duo' ? 'add-direct-debit-duo' : variant ? 'add-direct-debit-duo-outline' : 'add-direct-debit';
      case 'GOOGLE_PAY':
        return 'google-pay';
      case 'PAY_PAL':
        return variant === 'duo' ? 'paypal-branded-duo' : variant ? 'paypal-branded-duo-outline' : 'paypal-branded';
      case 'TEAM_BUDGET':
      default:
        return null;
    }
  }
}
